var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-badge',{attrs:{"variant":_vm.badgeColor}},[(!_vm.faIcon)?_c('span',[_vm._v(_vm._s(_vm.badgeText))]):_c('i',{class:_vm.faIconClass})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }